import React from "react";
import Layout from "../components/layout";
import { graphql } from "gatsby";
import renderAst from "../utils/ast-compiler";
import { Header, List, Label } from "semantic-ui-react";
import { I18Link } from "../components/i18link";
import { FormattedMessage } from "react-intl";

const SupportPage = ({ pageContext: { language, title, id, canonicalpath }, data }) => {
  const { post, similarPosts } = data;
  return (
    <Layout locale={language} title={title} pageId={id} canonicalpath={canonicalpath} description={post.excerpt}>
      <Header as="h1">
        <Header.Content>
          {post.frontmatter.title}
          {post.frontmatter.tags &&
            post.frontmatter.tags
              .filter(tag => tag !== "faq")
              .map((tag, index) => (
                <Label key={`q_${post.id}_tag_${index}`} size="mini">
                  {<FormattedMessage id={`support.categories.${tag}`} />}
                </Label>
              ))}
        </Header.Content>
        <Header.Subheader>
          <List divided horizontal link>
            <List.Item>
              <I18Link id="support" autotext icon="left arrow" />
            </List.Item>
            <List.Item><FormattedMessage id="page.support.title" /></List.Item>
          </List>
        </Header.Subheader>
      </Header>

      {/* <h2>{post.frontmatter.title}</h2> */}
      <div>{renderAst(post.htmlAst)}</div>

      <Header as="h2"><FormattedMessage id="support.see-also" /></Header>
      <List  link>
      {similarPosts && similarPosts.edges && similarPosts.edges.map((element, index) => (
        <List.Item as={I18Link} key={`sp_${index}`} id={element.node.context.id}>{element.node.context.title}</List.Item>
      ))}
      </List>
      
    </Layout>
  );
};

export default SupportPage;
export const query = graphql`
  query SupportPageQuery(
    $slug: String!
    $tags_re: String!
    $language: String!
    $id: String!
  ) {
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      htmlAst
      excerpt
      frontmatter {
        title
        tags
      }
      fields {
        id
        language
        slug
      }
    }

    similarPosts: allSitePage(
      filter: {
        context: {
          tags_re: { eq: $tags_re }
          language: { eq: $language }
          id: { ne: $id }
          summary: { eq: false }
        }
      }
    ) {
      edges {
        node {
          context {
            title
            id
          }
        }
      }
    }
  }
`;
